<template>
  <div :class="classes.content">
    <div :class="[classes.cardContent, 'win-win']">
      <div :class="classes.marketOptions">
        <WinOption
          :key="key1"
          :class="classes.marketOption"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[0]"
          :competitor="competitors[0]"
          :textWidth="useTeamIcons ? 77 : 109"
          homeOrAwayTeam="home"
          :stagger="0"
          :isLeft="true"
          :disableBadges="!useTeamIcons"
        />

        <LinkWrapper
          :href="event?.eventUrl"
          target="_blank"
          :class="classes.vsLinkWrapper"
          @click="handleClick"
        >
          <TeamVersusIcon
            :eventId="eventId"
            :class="classes.vs"
            :forceText="'VS'"
          />
        </LinkWrapper>
        <WinOption
          :key="key2"
          :stagger="1"
          :class="classes.marketOption"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[1]"
          :competitor="competitors[1]"
          :alignbadge="'right'"
          :textWidth="useTeamIcons ? 77 : 109"
          homeOrAwayTeam="away"
          :disableBadges="!useTeamIcons"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, ComputedRef, defineComponent, ref } from "vue";
import WinOption from "../../../WinOptionMobileBranded.vue";
import TeamVersusIcon from "../../../TeamVersusIcon.vue";
import {
  composeHomeAwayOptions,
  composeEventCompetitors,
  composeEvent
} from "@fresh8/ad-data-composition/src/betData";
import LinkWrapper from "../../../LinkWrapper.vue";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { SportCompetitor } from "@fresh8/types/src/betData";
import {
  injectTeamColors,
  injectUseTeamBadges
} from "../../../../lib/teamBranding";
import { injectUseTeamJerseys } from "../../../../lib/teamJerseys";
import { useCenterMobileLeaderboard } from "../../../../hooks/useLayout";

const useStyles = createUseStyles({
  //@ts-ignore
  content: props => ({
    display: "flex",
    flexDirection: "row",
    padding: "4px",
    height: "inherit",
    ...props.mlbCenterStyles
  }),
  cardContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",

    "& .team-jersey": {
      maxHeight: "30px"
    }
  },
  marketOptions: {
    flex: 1,
    display: "flex",
    width: "100%"
  },
  vsLinkWrapper: {
    display: "flex"
  },
  marketOption: {
    flex: "1 1 28%",
    "&:first-of-type": {
      flex: "1 1 36%",
      marginRight: 0
    },
    "&:last-of-type": {
      flex: "1 1 36%"
    },

    "& .meta-text": {
      fontSize: "7px"
    },
    "& .odds-text": {
      fontSize: "12px"
    },
    "& p": {
      lineHeight: "1"
    },

    "& a": {
      padding: "1px 0"
    }
  },
  vs: {
    display: "flex",
    flex: "1 1 8%",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    minWidth: "28px",
    maxWidth: "28px",
    minHeight: "28px",
    maxHeight: "28px",
    borderRadius: "90px",
    margin: "auto 5px"
  }
});

export default defineComponent({
  name: "MobileLeaderboardWW",
  components: {
    WinOption,
    TeamVersusIcon,
    LinkWrapper
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const event = composeEvent(props.eventId);
    const marketId = ref([props.marketId]);

    const mlbCenterStyles = useCenterMobileLeaderboard();
    const computedStyles = computed(() => ({
      mlbCenterStyles: mlbCenterStyles.value
    }));
    const classes = useStyles(computedStyles);
    const ftrMarkets = composeHomeAwayOptions(marketId);
    const competitors = composeEventCompetitors(props.eventId) as ComputedRef<
      SportCompetitor[]
    >;

    const useTeamBadges = injectUseTeamBadges();
    const useTeamJerseys = injectUseTeamJerseys();

    const teamColorsContext = injectTeamColors();

    // REFACTOR move into WinOption
    const useTeamIcons = computed(
      () => teamColorsContext.teamIconsAvailable.value
    );

    const { handleClick } = useAnalytics(props, "Odds Button");

    return {
      event,
      handleClick: () => handleClick(),
      useTeamJerseys,
      useTeamBadges,
      useTeamIcons,

      competitors,
      classes,
      ftrMarkets
    };
  },
  data() {
    return {
      key1: Math.random(),
      key2: Math.random()
    };
  },
  methods: {
    syncUpdate() {
      this.key1 = Math.random();
      this.key2 = Math.random();
    }
  }
});
</script>

<style></style>
